module.exports = "/fonts/vendor/boxicons/boxicons.woff?3a0cb82447f8e9ce865a709a92f0c752";